import React, { useState, useEffect, useContext } from 'react';
import { Modal, Button, Table } from 'react-bootstrap';
import Select from 'react-select';
import DatePicker from 'react-date-picker';
import 'react-calendar/dist/Calendar.css';
import 'react-date-picker/dist/DatePicker.css';
import { Tooltip } from '@mui/material';
// import { AddUpdateProject, GetProjectModel } from 'services/Project/ProjectApi';
import Text_Editor from './Text_Editor';
import { ERROR_MESSAGES } from '../components/GlobalMassage';
import { GetBlogModal } from '../../Services/Blog/BlogApi';
import { useAuth } from '../../Context/AuthContext';

const AdminBlogViewModal = ({ show, onHide, setIsAddUpdateActionDone, modelRequestData }) => {
  const { setLoader, user } = useAuth()
  const [modelAction, setModelAction] = useState('');
  const [error, setErrors] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState();

  const [stateOption, setStateOption] = useState([]);
  const [companyOption, setCompanyOption] = useState([]);
  const [districtOption, setDistrictOption] = useState([]);
  const [talukaOption, setTalukaOption] = useState([]);
  const [villageOption, setVillageOption] = useState([]);


  const [projectObj, setProjectObj] = useState({

    projectKeyID: null,
    projectName: null,
    projectSiteLocation: null,
    date: null,
    projectClient: null,
    projectDepartment: null,
    stampPhoto: null,
    signaturePhoto: null
  });

  const [blogObj, setBlogObj] = useState({
    blogKeyID: null,
    projectName: null,
    slug: null,
    publishDate: null,
    projectClient: null,
    featureImage: null,
    signaturePhoto: null,
    blogDescription: null,
  });

  // front addhar img
  const [aadhaarFrontImage, setAadhaarFrontImage] = useState(null);
  const [aadhaarFrontImagePreview, setAadhaarFrontImagePreview] = useState('');
  const [aadhaarFrontSizeError, setAadhaarFrontSizeError] = useState();

  const [uploadAadhaarFrontImageObj, setUploadAadhaarFrontImageObj] = useState({
    // userId: user.userKeyID,
    projectName: 'GPS_VELVET',
    imageFile: projectObj.AadhaarFrontUrl,
    moduleName: 'Customer_Staff'
  });

  // back aadhar img
  const [aadhaarBackImage, setAadhaarBackImage] = useState(null);
  const [aadhaarBackImagePreview, setAadhaarBackImagePreview] = useState('');
  const [aadhaarBackSizeError, setAadhaarBackSizeError] = useState();

  const [uploadAadhaarBackImageObj, setUploadAadhaarBackImageObj] = useState({
    // userId: user.userKeyID,
    projectName: 'GPS_VELVET',
    imageFile: projectObj.AadhaarBackUrl,
    moduleName: 'Customer_Staff'
  });

  useEffect(() => {
    if (modelRequestData?.Action === 'Update') {
      if (modelRequestData?.BlogKeyID !== null) {
        GetBlogModalData(modelRequestData.BlogKeyID);
      }
    }
  }, [modelRequestData?.Action]);





  const closeAllModal = () => {
    onHide();
    setShowSuccessModal(false);
  };

  const handleDescriptionChange = (htmlContent) => {
    setProjectObj((obj) => ({
      ...obj,
      projectName: htmlContent
    }));
  };








  const GetBlogModalData = async (id) => {

    setLoader(true);
    if (id === undefined) {
      return;
    }

    try {
      const data = await GetBlogModal(id);
      if (data?.data?.statusCode === 200) {
        setLoader(false);

        console.log(data, 'dsadas324r');
        const ModelData = data.data.responseData.data; // Assuming data is an array
        console.log(ModelData.Title, 'dsaiygd9s7a6ydsadsa');

        setBlogObj({
          ...blogObj,
          title: ModelData.title,
          slug: ModelData.slug,
          publishDate: ModelData.publishDate,
          featureImage: ModelData.featureImage,
          metaTitle: ModelData.metaTitle,
          metaDescription: ModelData.metaDescription,
          blogDescription: ModelData.blogDescription,
          blogKeyID: ModelData.blogKeyID,

          featureImage: ModelData.featureImage,

        });

      } else {
        // setLoader(false);
        // Handle non-200 status codes if necessary
        console.error('Error fetching data: ', data?.data?.statusCode);
      }
    } catch (error) {
      // setLoader(false);
      console.error('Error in Customer : ', error);
    }
  };




  const handleDateChange = (event) => {
    const selectedDate = event.target.value; // Gets the date in "YYYY-MM-DD" format
    setProjectObj((prev) => ({
      ...prev,
      date: selectedDate,
    }));
  };
  return (
    <>
    {show && <div className="custom-backdrop" />}
      <Modal size="lg" show={show} style={{ zIndex: 1300 }} onHide={onHide} backdrop="static" keyboard={false} centered>
        <Modal.Header closeButton>
          <>
            <h3 className="text-dark">
              Blog 
            </h3>
          </>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-center mb-3">
            <img
              src={blogObj.featureImage}
              alt="Feature"
              style={{
                width: "120px",
                height: "120px",
                objectFit: "cover",
                borderRadius: "10px",
                border: "1px solid #ddd",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              }}
            />
          </div>
          <div className="scrollable-table">
            <Table striped bordered hover>
              <tbody>

                <tr>
                  <td>
                    <b> Blog Title</b>
                  </td>
                  <td>{blogObj.title}</td>
                </tr>
               
                <tr>
                  <td>
                    <b>Publish Date</b>
                  </td>
                  <td>{blogObj.publishDate}</td>
                </tr>
              
                
                <tr>
                  <td>
                    <b>Blog Description</b>
                  </td>
                  <td dangerouslySetInnerHTML={{ __html: blogObj.blogDescription }}></td>

                  {/* <td dangerouslySetInnerHTML={{ __html: row.BlogDescription }}>{blogObj.blogDescription}</td> */}
                </tr>
                <tr>

                </tr>
              </tbody>
            </Table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button 
           type="submit"
           style={{
             color: "white",
             backgroundColor: "#blue",
             borderColor: "#f08143",
           }}
           className=" rts-btn    text-center"
             onClick={onHide}>
            Close
          </Button>

        </Modal.Footer>
      </Modal>
      {/* {showSuccessModal && (
        <SuccessPopupModal
          show={showSuccessModal}
          onHide={() => closeAllModal()}
          setShowSuccessModal={setShowSuccessModal}
          modelAction={modelAction}
        />
      )} */}
    </>
  );
};

export default AdminBlogViewModal;
